import {mapValues} from '@shared/helpers/object'

import makeSlice from '@web/slices/merchants/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const merchantsSlice = makeSlice({
    extraReducers(builder) {
        builder.addCase(initOrderSheetByAPI.fulfilled, (_state, {payload: {merchantsByMerchantNo}}) => {
            return mapValues((merchants) => {
                return {
                    ...merchants,
                    provisionUrl: merchants.provisionUrl ?? undefined,
                    mobileProvisionUrl: merchants.mobileProvisionUrl ?? undefined,
                    unsupportedPaymentMethods: [],
                    relations: [],
                    isPointAccumulationAvailable: true,
                }
            }, merchantsByMerchantNo)
        })
    },
})

export default merchantsSlice.reducer
export const actions = {...merchantsSlice.actions}
